module.exports = __webpack_public_path__ + "img/Logo-liga.741c9eb2.png";